<nav class="wrapper">
  <ng-container *ngIf="addMarketplace">
    <a [routerLink]="marketplacePath">{{ marketplaceLabel }}</a>
    <span>&nbsp;/&nbsp;</span>
  </ng-container>
  <ng-container *ngFor="let item of items; let last = last">
    <a *ngIf="!!item.path" [routerLink]="item.path">{{ item.label }}</a>
    <span *ngIf="!item.path">{{ item.label }}</span>
    <span *ngIf="!last">&nbsp;/&nbsp;</span>
  </ng-container>
</nav>
